module.exports = __webpack_public_path__ + "static/media/flag.0ac78d6a.gif";